import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=78614d0f&scoped=true&"
import script from "./compliance.vue?vue&type=script&lang=js&"
export * from "./compliance.vue?vue&type=script&lang=js&"
import style0 from "./compliance.vue?vue&type=style&index=0&id=78614d0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78614d0f",
  null
  
)

export default component.exports